<template>
  <div id="image_view" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="contentViewLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content" style="background:none;border: none;">
        <div class="modal-body">
          <div class="row">
            <div class="col-12 position-relative" @dragstart.prevent style="user-select: none; -webkit-touch-callout: none; overflow: hidden; border-radius: 8px;">
              <img style="object-fit: cover;width: 100%;margin: 0; -webkit-user-drag: none; -webkit-touch-callout: none; user-select: none;" class="image-responsive" :src="src" alt="" />
              <!-- The watermark overlay catches all clicks to prevent image right-click context -->
              <div class="watermark-container" v-if="user" style="pointer-events: auto;">
              </div>
              
              <!-- Creator Info & Description Overlay -->
              <div v-if="influencer" class="media-info-overlay">
                <div class="d-flex align-items-center mb-2" style="gap: 10px;">
                  <message-avatar :user-id="influencer.id" size="44px" class="shadow-sm" style="border: 2px solid rgba(255,255,255,0.2); border-radius: 50%; display: inline-flex;" />
                  <div class="text-white text-left">
                    <div class="font-weight-bold font-size-15" style="text-shadow: 0 1px 4px rgba(0,0,0,0.8);">{{ influencer.name }}</div>
                    <div v-if="description" class="font-size-13 mt-1" style="max-width: 90%; opacity: 0.9; text-shadow: 0 1px 4px rgba(0,0,0,0.8);">{{ description }}</div>
                  </div>
                </div>
              </div>
              <button type="button"
                      class="close image-close-btn"
                      data-dismiss="modal"
                      aria-hidden="true"
                      style="z-index: 20;"
                      @click="$emit('close')">&times;</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MessageAvatar from "@/components/module/shared/direct-message/MessageAvatar";

export default {
  name: "ModelImageView",
  components: { MessageAvatar },
  data() {
    return {
      src: null,
      user: null,
      influencer: null,
      description: null
    }
  },
  methods: {
    show(src, user = null, influencer = null, description = null) {
      this.src = src;
      this.user = user;
      this.influencer = influencer;
      this.description = description;
      $('#image_view').modal('show');
    },
    hide() {
      $('#image_view').modal('hide');
    }
  }
}
</script>

<style scoped>
/* Watermark styles for DRM deterrent */
.watermark-container {
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  /* Catch all clicks */
  overflow: hidden;
  opacity: 0.20; /* Subtle enough not to ruin the content */
  z-index: 10;
  /* background-image: url('~@/assets/images/stella/logo-stella-white.png'); replaced */
  background-repeat: repeat-x;
  background-size: 150px;
  background-position: center;
  transform: rotate(-25deg);
}
.media-info-overlay {
  position: absolute;
  bottom: 0; left: 0; right: 0;
  padding: 60px 16px 20px;
  background: linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0) 100%);
  pointer-events: none;
  z-index: 15;
}
.image-close-btn {
  position: absolute;
  top: 5%;
  right: 4%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  color: white;
  padding: 12px 24px;
  cursor: pointer;
}
</style>
